export const toastSelector = state => state.toasts.toasts;
